import { Col, Collapse, Row } from 'antd';

import { useIntl } from 'react-intl';
import InvoicePaymentConditionBillingData from './InvoicePaymentConditionBillingData';
import InvoiceInstallment from './InvoiceInstallment';
import InvoicePaymentCondition from './InvoicePaymentCondition';
import { useInvoiceFormContext } from '../../InvoiceFormProvider';

export default function InvoicePaymentConditionGeneralForm() {
  const { disabledFields } = useInvoiceFormContext();

  const intl = useIntl().formatMessage;
  const translate = (message: string) =>
    intl({ id: `invoicePaymentCondition.label.${message}` });

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Collapse accordion destroyInactivePanel={true}>
          <Collapse.Panel key="PaymentCondition" header={translate('payments')}>
            <InvoicePaymentCondition disabledFields={disabledFields} />
          </Collapse.Panel>

          <Collapse.Panel key="Billing" header={translate('billingData')}>
            <InvoicePaymentConditionBillingData
              disabledFields={disabledFields}
            />
          </Collapse.Panel>

          <Collapse.Panel key="Installment" header="Parcelas">
            <InvoiceInstallment disabledFields={disabledFields} />
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
}
